// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var container = "SideMenu-module--container--4bnot";
export var accordion = "SideMenu-module--accordion--37ufA";
export var accordionBox = "SideMenu-module--accordionBox--2yN3R";
export var selected = "SideMenu-module--selected--36oRh";
export var disabled = "SideMenu-module--disabled--DAUhf";
export var icon = "SideMenu-module--icon--3fw9o";
export var body = "SideMenu-module--body--OuHTm";
export var subMenuEntry = "SideMenu-module--subMenuEntry--2QB12";
export var barb = "SideMenu-module--barb--1SpoH";
export var line = "SideMenu-module--line--2CCob";
export var accordionOpen = "SideMenu-module--accordionOpen--3gKKH";
export var entry = "SideMenu-module--entry--1mSso";